import classnames from "classnames";
import type { Frontmatter } from "~/utils/blog_post.server";
import { Filter } from "./Filter";

interface Props {
	posts: { slug: string; frontmatter: Frontmatter }[];
}

export function BlogTimeline({ posts }: Props) {
	return (
		<>
			{/* <Filter /> TODO: Fix this */}
			<ul className="timeline timeline-snap-icon max-md:timeline-compact timeline-vertical">
				{posts.map((post, i) => {
					const classesForInnerItem = classnames({
						"timeline-start": i % 2 === 0,
						"timeline-end": i % 2 === 1,
						"md:text-end": true,
						"mb-10": true,
					});
					return (
						<li key={post.slug}>
							<div className="timeline-middle">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 20 20"
									fill="currentColor"
									className="h-5 w-5"
									aria-hidden="true"
								>
									<path
										fillRule="evenodd"
										d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
										clipRule="evenodd"
									/>
								</svg>
							</div>
							<div className={classesForInnerItem}>
								<a href={`/blog/${post.slug}`}>
									<time className="font-mono italic">
										{post.frontmatter.date}
									</time>
									<div className="text-lg font-black">
										{post.frontmatter.title}
									</div>
									<div>
										<div className="badge badge-outline badge-xs">
											{post.frontmatter.category}
										</div>
									</div>
								</a>
							</div>
							<hr />
						</li>
					);
				})}
			</ul>
		</>
	);
}
